import { useCallback, useState } from "react";
import { $DELETE } from "../../../api/index";

const TableContentItem = ({ data, id, route }) => {
  const [isEdit, setIsEdit] = useState(false);

  const deleteService = useCallback(async () => {
    try {
      await $DELETE(`${route}/${id}`);
    } catch (err) {
      throw new Error(err.message);
    }
  }, []);

  return (
    <ul key={id}>
      {Object.keys(data).map((item) => {
        return item !== "__v" && <li key={item._id}>{data[item] || "-"}</li>;
      })}
      <li onClick={deleteService} className="empty delete-button">
        Delete
      </li>
    </ul>
  );
};

export default TableContentItem;
